import classNames from 'classnames/bind';
import styles from './Modal.module.scss';
import { useTranslation } from 'react-i18next';
import ModalInterface from '@components/commons/Modal';
import imageAlert from '@assets/images/icon_warning.png';

const cx = classNames.bind(styles);

const ModalNotification: IModalComponent<IModalNotificationProps> = (props) => {
    const { header, isShow, handleOK } = props;

    const { t } = useTranslation();

    return (
        <ModalInterface
            hideNegativeButton
            dialogClassname={cx('modal-delete-width')}
            modalHeader={header}
            isShow={isShow}
            handleOK={handleOK}
            positiveButtonText='common.ok'>
            <div className="row d-flex flex-column p-1">
                <div className={'d-flex justify-content-center'}>
                    <img src={imageAlert} alt="" />
                </div>
                <hr className={'w-100 my-2'} />
                <div className={'col text-center'}>
                    <span className={cx('text-content', 'text-bold')}>{t('message.no_internet_connection')}</span>
                    <br />
                    <span className={cx('text-content')}>{t('message.please_check')}</span>
                </div>
            </div>
        </ModalInterface>
    );
};

ModalNotification.defaultProps = {
    isShow: false,
};

export default ModalNotification;
